//#region src/hooks/infiniteListQueryOptions.ts
function e(e) {
	let { queryKey: t, fetchPage: n, ...r } = e;
	return {
		queryKey: t,
		queryFn: ({ pageParam: e }) => n(e),
		initialPageParam: 1,
		getNextPageParam: (e, t) => e.hasMore ? t.length + 1 : void 0,
		...r
	};
}
//#endregion
export { e as infiniteListQueryOptions };
